import { AuthService } from './authService';
import { UserProfileDto, UpdateUserProfileRequest } from '../types/userProfile';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class UserProfileService {
  
  async getCurrentUserProfile(): Promise<UserProfileDto> {
    const response = await AuthService.authenticatedGet(`${API_BASE_URL}/user-profiles/current`);
    
    if (!response.ok) {
      throw new Error(`Failed to get current user profile: ${response.status}`);
    }
    
    return await response.json();
  }
  
  async updateCurrentUserProfile(profile: UpdateUserProfileRequest): Promise<UserProfileDto> {
    const response = await AuthService.authenticatedPut(`${API_BASE_URL}/user-profiles/current`, profile);
    
    if (!response.ok) {
      throw new Error(`Failed to update current user profile: ${response.status}`);
    }
    
    return await response.json();
  }
}

export const userProfileService = new UserProfileService();
